// extracted by mini-css-extract-plugin
export var alignCenter = "styles-module--alignCenter--0213e";
export var alignLeft = "styles-module--alignLeft--4e34c";
export var alignRight = "styles-module--alignRight--1093e";
export var background = "styles-module--background--5a39a";
export var backgroundOverlay = "styles-module--backgroundOverlay--289c3";
export var body = "styles-module--body--82d7b";
export var clientLogos = "styles-module--clientLogos--53552";
export var clientLogosMarquee = "styles-module--clientLogosMarquee--25639";
export var clientLogosText = "styles-module--clientLogosText--d9a62";
export var clientLogosTextLockup = "styles-module--clientLogosTextLockup--69de7";
export var clientLogosWithText = "styles-module--clientLogosWithText--559b6";
export var container = "styles-module--container--3935a";
export var desktop = "1340px";
export var figure = "styles-module--figure--8abe8";
export var giant = "2200px";
export var grid = "styles-module--grid--6437f";
export var gridWithLogosText = "styles-module--gridWithLogosText--b8c5c";
export var heading = "styles-module--heading--52aa3";
export var heroContent = "styles-module--heroContent--75745";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var logo = "styles-module--logo--ebfea";
export var logos = "styles-module--logos--805f2";
export var marquee = "styles-module--marquee--b58b6";
export var mobile = "400px";
export var paddedBackground = "styles-module--paddedBackground--2c489";
export var paddedBackgroundDark = "styles-module--paddedBackgroundDark--25e05";
export var paddedBackgroundLight = "styles-module--paddedBackgroundLight--a427e";
export var scrollX = "styles-module--scroll-x--01832";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";
export var text = "styles-module--text--a7e0e";
export var viewport = "styles-module--viewport--283eb";
export var viewportNoLogos = "styles-module--viewportNoLogos--a470b";